// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__3gojE","Open":"SideDrawer__Open__U5PaR","Close":"SideDrawer__Close__3VCHf"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SideDrawer/SideDrawer.css
// module id = 110
// module chunks = 0